module.exports = __webpack_public_path__ + "img/186.toilets.ea591185.svg";